import {invalidateQueries, q} from "../../state";
import {CreateTprmAsset, TprmAsset, TprmAssetId, UpdateTprmAsset} from "platformed-client/types";
import {platformedClient} from "..";

export async function list(): Promise<TprmAsset[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/assets", {});
}

export async function create(asset: CreateTprmAsset) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/assets", {body: asset});
  await invalidateQueries([q.tprm.assets.filter()]);
  return res;
}

export async function update(assetId: TprmAssetId, update: UpdateTprmAsset) {
  const res = await platformedClient.internalRequest("patch", "/region/{region}/api/tprm/assets/{asset_id}", {
    path: {asset_id: assetId},
    body: update,
  });
  await invalidateQueries([q.tprm.assets.filter()]);
  return res;
}

export async function delete_(assetId: TprmAssetId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/assets/{asset_id}", {
    path: {asset_id: assetId},
  });
  await invalidateQueries([q.tprm.assets.filter()]);
  return res;
}
